const TOKEN_KEY = 'us_space_token'
const USER_KEY = 'us_space_user'
const REMEMBER_KEY = 'us_space_remember_login'
const REMEMBER_FORM_KEY = 'us_space_remember_form'

let handlingUnauthorized = false

export const getAuthToken = () => localStorage.getItem(TOKEN_KEY)

export const getStoredUser = () => localStorage.getItem(USER_KEY)

export const persistAuth = (data) => {
  localStorage.setItem(TOKEN_KEY, data.token)
  localStorage.setItem(USER_KEY, JSON.stringify(data.user || null))
  window.dispatchEvent(new Event('us-auth-changed'))
}

export const clearAuth = () => {
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(USER_KEY)
  window.dispatchEvent(new Event('us-auth-changed'))
}

export const getRememberLoginEnabled = () => localStorage.getItem(REMEMBER_KEY) === '1'

export const getRememberedLoginForm = () => {
  try {
    const raw = localStorage.getItem(REMEMBER_FORM_KEY)
    return raw ? JSON.parse(raw) : null
  } catch (error) {
    return null
  }
}

export const setRememberedLoginForm = (payload) => {
  localStorage.setItem(REMEMBER_KEY, '1')
  localStorage.setItem(REMEMBER_FORM_KEY, JSON.stringify({
    username: payload.username || '',
    password: payload.password || ''
  }))
}

export const clearRememberedLoginForm = () => {
  localStorage.removeItem(REMEMBER_KEY)
  localStorage.removeItem(REMEMBER_FORM_KEY)
}

export const syncRememberedLoginForm = (enabled, payload) => {
  if (enabled) {
    setRememberedLoginForm(payload)
    return
  }

  clearRememberedLoginForm()
}

export const handleUnauthorized = (message = '登录已失效，请重新登录') => {
  if (handlingUnauthorized) {
    return
  }

  handlingUnauthorized = true
  clearAuth()
  sessionStorage.setItem('us_space_auth_expired', message)

  const { pathname, search, hash } = window.location
  const redirect = `${pathname}${search}${hash}`
  const loginUrl = redirect && redirect !== '/'
    ? `/?redirect=${encodeURIComponent(redirect)}`
    : '/'

  window.location.replace(loginUrl)

  window.setTimeout(() => {
    handlingUnauthorized = false
  }, 1000)
}
